<mat-card appearance="outlined" color="primary" data-tfa="card-accueil-component">
    <mat-card-header>
        <mat-card-title role="heading" aria-level="1"><h1>Bienvenue</h1></mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <p></p>
    </mat-card-content>
</mat-card>
